import { type ClassValue, clsx } from 'clsx';

/**
 * Class merger — clsx only, deliberately WITHOUT `tailwind-merge`.
 *
 * The admin uses twMerge; this app does not, and the reason is measured rather
 * than assumed. On this bundle it costs 27.6 kB raw / 8.6 kB gzip — more than
 * the entire shadcn component layer and the lucide icons put together (which
 * come to 25.3 kB / 8.1 kB and 3.9 kB / 1.3 kB respectively).
 *
 * §7 budgets this app's bundle for a mid-range Android on Cambodian mobile
 * data, and §6.3 puts a Facebook-ad customer on this page as their first
 * impression. Nine kilobytes of gzip to resolve class conflicts is a poor
 * trade when there are roughly ten call sites and all of them are in this
 * repository. The admin makes the opposite trade for the opposite reason:
 * a hundred call sites, a merchant on WiFi, and §7's own "form/table velocity".
 *
 * What this costs us: two conflicting Tailwind utilities on one element are
 * resolved by stylesheet order, not by which came last in the attribute. So
 * components here expose VARIANTS for the things a caller needs to change
 * (`variant`, `width`) rather than expecting a className to override a default.
 * If you find yourself passing `className="w-auto"` to override `w-full`, add
 * a variant instead.
 */
export function cn(...inputs: ClassValue[]) {
  return clsx(inputs);
}
